import React from "react";

const Modal = ({
  children,
  onClose,
  extraClass,
}) => {
  return (
    <div>
      <div className="modal__overlay" onClick={onClose}> </div>
      <div className="modal">

        <div className={`${extraClass} modal__content`}>
          {children}
        </div>
      </div>
    </div>
  )      
}

export default Modal;